const transformThreeDS2Config = _ref => {
  let {
    provider_config,
    provider
  } = _ref;
  return {
    providerConfig: {
      apiKey: provider_config.api_key,
      site: provider_config.site
    },
    provider
  };
};

export const transformCheckoutConfigurationDto = _ref2 => {
  let {
    threeds2
  } = _ref2;
  return {
    threeDS2: threeds2 ? transformThreeDS2Config(threeds2) : null
  };
};